let sortByProps = function (props) {
  return function (row1, row2) {
    let a;
    let b;

    for (let i = 0; i < props.length; i++) {
      a = row1[props[i]];
      b = row2[props[i]];

      if (a !== b) {
        break;
      }
    }

    return (a || "") > (b || "") ? 1 : -1;
  };
};

class Table extends React.Component {
  render() {
    let data = [].concat(this.props.data);

    let cols = this.props.cols.map(function (col, i) {
      return <col width={col.width} key={i}/>;
    });

    let thead = this.props.cols.map(function (col) {
      let sort = col.sort;
      let sortable = !!sort;

      if (col.prop === this.props.sort) {
        if (sort === true) {
          sort = col.prop;
        }

        if (typeof sort !== "function") {
          sort = sortByProps([].concat(sort, this.props.rowKey));
        }

        data.sort(sort);
      }

      let handleClick = (function (evt) {
        let direction = col.prop === this.props.sort ? this.props.direction * -1 : 1;

        this.props.onSort(col.prop, direction);
      }).bind(this);

      return (
        <th
          key={col.prop}
          data-key={col.prop}
          onClick={sortable ? handleClick : undefined}
          data-sortable={sortable}
          data-sorted={!!sort && col.prop === this.props.sort ? this.props.direction : null}>
            {col.label}
        </th>
      );
    }, this);

    let rows = data.map(function (row, i) {
      let cols = this.props.cols.map(function (col) {
        return (
          <td key={col.prop} data-key={col.prop} data-clip={!!col.clip}>
            {(col.content && col.content(row, i, data.length)) || row[col.prop]}
          </td>
        );
      });

      let key = row[this.props.rowKey];

      return (
        <tr key={key} data-key={key}>
          {cols}
        </tr>
      );
    }, this);

    if (this.props.direction === -1) {
      rows.reverse();
    }

    return (
      <table className="mc-table" data-align={this.props.align} id={this.props.id}>
        <colgroup>
          {cols}
        </colgroup>
        <thead>
          <tr>
            {thead}
          </tr>
        </thead>
        <tbody>
          {rows}
        </tbody>
      </table>
    );
  }
}

Table.defaultProps = {
  rowKey: "id",
  cols: [],
  data: [], // TODO rename "rows"
  sort: null,
  direction: 1,
  onSort: null,
  align: "top"
};

module.exports = Table;
